import { reactive } from "vue";
import * as clienteService from "@/services/clienteService";


interface IControleStore {
  token: string,
  usuario?: clienteService.ClienteLoginResult | null
}

const stateControle: IControleStore = reactive({
  token: "",
  usuario: null
});


export default stateControle;
